<template>
  <div v-if="props.loadedData" :class="['widget-base-component', customClass]">
    <div v-resize="calculateMainHeight" class="main-section">
      <header v-if="showHeader">
        <slot name="header"></slot>
      </header>
      <main>
        <slot name="body"></slot>
      </main>
    </div>
    <footer v-if="showFooter">
      <slot name="footer"></slot>
    </footer>
  </div>

  <SpinnerLayerComponent v-else class="spinner-layer" />
</template>

<script setup lang="ts">
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'

const props = defineProps({
  loadedData: {
    type: Boolean,
    default: true
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  customClass: {
    type: String,
    default: ''
  },
  showHeader: {
    type: Boolean,
    default: true
  }
})

const calculateMainHeight = () => {
  setTimeout(() => {
    const el = document.querySelector('.widget-base-component') as HTMLElement
    if (!el) return

    const height = el.clientHeight
    const elementWithScroll = el.querySelector('.element-with-scroll') as HTMLElement

    if (elementWithScroll) {
      elementWithScroll.style.height = `${height - 120}px`
    }
  })
}
</script>

<style lang="scss" scoped>
.widget-base-component {
  display: flex;
  width: 100%;
  padding: $spacing-sm $spacing-md;
  flex-direction: column;
  align-items: flex-start;
  gap: $spacing-xxs;
  align-self: stretch;
  border-radius: $cornerRadius-md;
  border: 1px solid $main-300;
  background: $neutral-white-000;

  .main-section {
    width: 100%;

    header {
      display: flex;
      align-self: stretch;
      justify-content: space-between;
      align-items: center;
      color: $neutral-grey-800;
      padding: 8px 0;

      h2 {
        @include milano-bold-18;
        text-transform: lowercase;

        &:first-letter {
          text-transform: uppercase;
        }
      }
    }

    main {
      margin-top: 10px;
    }
  }
}

.spinner-layer {
  background-color: $white-01;
  border-radius: $widget-border-radius;
}
</style>
